import { buttonVariants } from "@/components/ui/button";
import { ExternalLink } from "@/components/ui/external-link";
import { cn } from "@/lib/utils";
import React from "react";

// The exact markup <Button asChild variant="outline" size="sm"> puts on the
// link, computed once: a hundred of these buttons per events page hydrated
// a Button and a Slot fiber each for output that never varies.
const ICON_BUTTON_CLASS = cn(
  buttonVariants({ variant: "outline", size: "sm" }),
  "text-muted-foreground rounded-full",
);

// The tooltip comes from the page's HoverTooltipDelegate, which reads
// data-tooltip: with a Tooltip per button the events page hydrated 1,938
// fibers and re-rendered 950 right after; with the shared one, 1,036 and
// none (adr/0012-share-one-hover-tooltip-across-the-page.md).
export function IconButton({
  href,
  ariaLabel,
  tooltipText,
  icon,
  className,
  "data-testid": dataTestId,
}: {
  href: string;
  ariaLabel: string;
  tooltipText: string;
  /** One of the element factories in ui/static-lucide. */
  icon: (className: string) => React.ReactNode;
  className?: string;
  "data-testid"?: string;
}) {
  return (
    <ExternalLink
      data-slot="button"
      className={cn(ICON_BUTTON_CLASS, className)}
      data-testid={dataTestId}
      data-tooltip={tooltipText}
      href={href}
      aria-label={ariaLabel}
    >
      {icon("size-4")}
    </ExternalLink>
  );
}
